import * as basePropTypes from 'src/constants/propTypes/base';

class Shared {
  propTypes = {
    errorMessages : basePropTypes.errorMessages.isRequired,
  };
}

export default Shared;
